export const negativeNarrativeFeedbackOptions = [
  { label: 'Not relevant to this analysis', value: 'not_relevant' },
  { label: 'This view did not support my story', value: 'not_supporting_story' },
  { label: 'The visualization is unclear', value: 'bad_viz' },
  { label: 'Other, not listed', value: 'other' },
];

export const positiveNarrativeFeedbackOptions = [
  { label: 'Data is relevant to my analysis', value: 'relevant' },
  { label: 'This data supports my story', value: 'supporting_story' },
  { label: 'The visualization is easy to comprehend', value: 'easy_viz' },
  { label: 'Other, not listed', value: 'other' },
];
